import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/site";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="主题分类"
          title="按你关心的领域找线索"
          desc="六个长期追踪的方向，覆盖消费、行业、程序与职场四个层面。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category, index) => (
            <Link
              key={category.key}
              to={`/cases?category=${category.key}`}
              className="group relative flex flex-col p-5 md:p-6 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/40 transition-colors"
            >
              <div className="flex items-start justify-between mb-4">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-md text-2xl ${
                    index % 3 === 1
                      ? "bg-accent-100 text-accent-800"
                      : "bg-background-100 text-primary-600"
                  }`}
                >
                  <i className={category.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-sm text-foreground-400">
                  {category.count} 篇
                </span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {category.label}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{category.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                进入分类
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}